﻿export class SessionError {
    static $type = 'Web.SessionError';
}